import React, { Component, Fragment, useEffect, useState } from 'react';

import StepsOne from "./Steps/StepOne"
import StepsTwo from './Steps/StepTwo';
import StepsThree from './Steps/StepThree';
import StepsFour from './Steps/StepFour';
import Steps from '../../commonComponents/Steps';
import { connect } from 'react-redux';
import { setConnectionType } from '../../../actions/index';
import { bindActionCreators } from 'redux';

let actualArray = {
    horizontalSteps: [
        {
            title: 'Data Source Type',
            isSelected: true,
            disabled: true,
            completeStatus: false,
            children: (<Fragment><StepsOne allData={this} /></Fragment>),
            onClick: () => this.changeState("1"),
        },
        {
            title: 'Configuration',
            disabled: false,
            completeStatus: false,
            isSelected: false,
            children: (<Fragment><StepsTwo allData={this} /></Fragment>),
            onClick: () => this.changeState("2"),
        },
        {
            title: 'Select Tables/ Files',
            disabled: false,
            completeStatus: false,
            isSelected: false,
            children: (<Fragment><StepsThree allData={this} /></Fragment>),
            onClick: () => this.changeState("3"),
        },
        {
            title: 'Load',
            disabled: false,
            completeStatus: false,
            isSelected: false,
            children: (<Fragment><StepsFour allData={this} /></Fragment>),
            onClick: () => this.changeState("4"),
        },
    ],
    children: {
        "step1": <Fragment><StepsOne allData={this} /></Fragment>,
        "step2": <Fragment><StepsTwo allData={this} /></Fragment>,
        "step3": <Fragment><StepsThree allData={this} /></Fragment>,
        "step4": <Fragment><StepsFour allData={this} /></Fragment>,
    }
}

function LoadData(props) {

    const [initialData, setInitialData] = useState({ ...actualArray, selectedStep: 1 });

    function setData(data) {
        let steps = initialData.horizontalSteps;
        steps.map(function (element, index) {
            steps[index].completeStatus = index < data.selectedStep - 1 ? true : false
            steps[index].isSelected = index == data.selectedStep - 1 ? true : false
        });
        setInitialData({ ...initialData, ...data })
    }

    function getSelectedStep(selectedStep) {
        switch (parseInt(selectedStep)) {
            case 1:
                return <Fragment><StepsOne initialData={initialData} authData={props.authData} setConnectionType={setData} /></Fragment>
            case 2:
                return <Fragment><StepsTwo initialData={initialData} authData={props.authData} setConnectionType={setData} /></Fragment>
            case 3:
                return <Fragment><StepsThree initialData={initialData} authData={props.authData} setConnectionType={setData} /></Fragment>
            case 4:
                return <Fragment><StepsFour initialData={initialData} authData={props.authData} /></Fragment>
        }
    }

    let stepName = getSelectedStep(initialData.selectedStep)
    let StepComponent = <Steps stepArray={initialData.horizontalSteps} />

    return (
        <div className="">
            {StepComponent}
            {stepName}
        </div>
    )
}

function mapStateToProps(state) {
    return { connection_type: state.admin.connection_type, authData: state.dataSet.authData };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setConnectionType
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadData);